exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".admin-area[data-v-844b62bc] {\n  padding: 32px;\n}", ""]);

// exports
